export const CLIENT_ID = '492747800382-qg2psjvru9nougfb2s29r7al9va21soo.apps.googleusercontent.com';
